import React from "react";
import DocumentViewer from "components/DocumentViewer";

const PrivacyPolicyPage: React.FC = () => {
    return <DocumentViewer titleKey="pages.login.privacyPolicy" documentType="privacy" />;
};

export default PrivacyPolicyPage;
